import { z } from 'zod';

const EDDQuestionAnswerSchema = z.union([
  z.object({
    id: z.number(),
  }),
  z.object({
    value: z.string(),
  }),
]);

const EDDQuestionSchema = z.object({
  question_id: z.string(),
  answers: z.array(EDDQuestionAnswerSchema),
});

const POADocumentSchema = z.object({
  file_id: z.string(),
  type: z.string(),
});

const AddressSchema = z.object({
  address_line_1: z.string(),
  address_line_2: z.string(),
  city: z.string(),
  state: z.string(),
  postcode: z.string(),
  country: z.string(),
  national_identifier: z.string(),
});

export const ActivateCurrencyParamsSchema = z.object({
  currency: z.string(),
  tncAccepted: z.boolean(),
  payment_network: z.string(),
  vendor_id: z.string(),
  edd_questions: z.array(EDDQuestionSchema).optional(),
  poa: z
    .object({
      documents: z.array(POADocumentSchema),
      address: AddressSchema,
    })
    .optional(),
});

const StepStatusSchema = z.object({
  completed: z.boolean(),
  completedAt: z.string().optional(),
  status: z.string().optional(),
});

export const ActivateCurrencyResultSchema = z.object({
  data: z.object({
    currency: z.string(),
    status: z.enum(['pending_review', 'activated']),
    steps: z.object({
      tnc: StepStatusSchema,
      edd: StepStatusSchema.optional(),
      poa: StepStatusSchema,
    }),
  }),
  message: z.string(),
  code: z.number().optional(),
});

export type ActivateCurrencyParams = z.infer<
  typeof ActivateCurrencyParamsSchema
>;
export type ActivateCurrencyResult = z.infer<
  typeof ActivateCurrencyResultSchema
>;
